// DS: i6.19
import React from 'react';
import IconWrap from '../../IconWrap';
const AddImage = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M13 5a1 1 0 110 2H4v9.27l1.88-1.88a1 1 0 011.32-.08l.1.08 1.61 1.62L6.08 19h2.76l5.86-6.2a1 1 0 011.41-.03l.04.04L18 14.97V12a1 1 0 112 0v8a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1h10zm-2.5 4a1.5 1.5 0 110 3 1.5 1.5 0 010-3zM19 3a1 1 0 011 1v1h1a1 1 0 110 2h-1v1a1 1 0 11-2 0V7h-1a1 1 0 110-2h1V4a1 1 0 011-1z",
        clipRule: "evenodd"
    })));
};
AddImage.displayName = 'AddImage';
export default AddImage;

//# sourceMappingURL=AddImage.js.map